var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    [
      _c("PageHeader", {
        attrs: { title: _vm.page.title, items: _vm.page.items }
      }),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { lg: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Key Word",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "key-words"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "key-words", trim: "" },
                                model: {
                                  value: _vm.search_condition.sensitiveWord,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "sensitiveWord",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.sensitiveWord"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Keyword Category",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "keyword-category"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "keyword-category",
                                  options: _vm.types.keywordCategoryList,
                                  "value-field": "value",
                                  "text-field": "text"
                                },
                                model: {
                                  value:
                                    _vm.search_condition
                                      .sensitiveWordCategoryId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "sensitiveWordCategoryId",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n\t\t\t\t\t\t\t\t\tsearch_condition.sensitiveWordCategoryId\n\t\t\t\t\t\t\t\t"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Risk Level",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "risk-level"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "risk-level",
                                  options: _vm.types.riskLevelList,
                                  "value-field": "value",
                                  "text-field": "text"
                                },
                                model: {
                                  value: _vm.search_condition.riskLevel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "riskLevel",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.riskLevel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Status",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "status"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  options: _vm.types.status,
                                  "value-field": "value",
                                  "text-field": "text"
                                },
                                model: {
                                  value: _vm.search_condition.status,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "status",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "3" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.search()
                                }
                              }
                            },
                            [_vm._v("Search")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-card",
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "keywordBlacklist::Create",
                          expression: "'keywordBlacklist::Create'"
                        }
                      ],
                      attrs: { variant: "primary" },
                      on: { click: _vm.gotoAdd }
                    },
                    [_vm._v("Create")]
                  ),
                  _c(
                    "div",
                    { staticClass: "table-responsive mb-0" },
                    [
                      _c("b-table", {
                        ref: "table",
                        attrs: {
                          "show-empty": "",
                          "empty-text": "no records",
                          id: "table",
                          "head-variant": "light",
                          busy: _vm.isBusy,
                          striped: true,
                          items: _vm.provider,
                          fields: _vm.fields,
                          "per-page": _vm.search_condition.pageSize,
                          "current-page": _vm.search_condition.pageNum,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          filter: _vm.filter,
                          "filter-includedfields": _vm.filterOn
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center text-danger my-2"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "align-middle"
                                    }),
                                    _c("strong", [_vm._v("Loading...")])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(index)",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      data.index +
                                        (_vm.search_condition.pageNum - 1) *
                                          _vm.search_condition.pageSize +
                                        1
                                    ) +
                                    " "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(actions)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-button-group",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "has",
                                            rawName: "v-has",
                                            value: "keywordBlacklist::Modify",
                                            expression:
                                              "'keywordBlacklist::Modify'"
                                          }
                                        ],
                                        staticClass: "mr-1",
                                        attrs: {
                                          size: "sm",
                                          variant: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.rowModify(
                                              row.item,
                                              row.index,
                                              $event.target
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(" Modify ")]
                                    ),
                                    row.item.status == 0
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "has",
                                                rawName: "v-has",
                                                value:
                                                  "keywordBlacklist::Enable",
                                                expression:
                                                  "'keywordBlacklist::Enable'"
                                              }
                                            ],
                                            staticClass: "mr-1",
                                            attrs: {
                                              size: "sm",
                                              variant: "success"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.rowEnable(
                                                  row.item,
                                                  row.index,
                                                  $event.target
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Enable ")]
                                        )
                                      : _vm._e(),
                                    row.item.status == 1
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "has",
                                                rawName: "v-has",
                                                value:
                                                  "keywordBlacklist::Disable",
                                                expression:
                                                  "'keywordBlacklist::Disable'"
                                              }
                                            ],
                                            staticClass: "mr-1",
                                            attrs: {
                                              size: "sm",
                                              variant: "secondary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.rowDisable(
                                                  row.item,
                                                  row.index,
                                                  $event.target
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Disable ")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm.has_data
                    ? _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dataTables_paginate paging_simple_numbers float-right"
                              },
                              [
                                _vm.rows != 0
                                  ? _c(
                                      "ul",
                                      { staticClass: "pagination mb-0" },
                                      [
                                        _c("b-pagination", {
                                          attrs: {
                                            "per-page": 10,
                                            "total-rows": _vm.rows,
                                            "aria-controls": "table"
                                          },
                                          model: {
                                            value: _vm.search_condition.pageNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.search_condition,
                                                "pageNum",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "search_condition.pageNum"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }